export function truncate(string, characters, useWordBoundary = true) {
  string = String(string)

  if (string.length <= characters) {
    return string
  }
  const subString = string.substr(0, characters - 1)
  return (
    (useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(' '))
      : subString) + '…'
  )
}

export function formatArrayToString(array, key = null, fallback = '') {
  if (!array.length) return fallback

  if (key) {
    return array.map((el) => el[key]).join(', ')
  } else {
    return array.join(', ')
  }
}

export function singularOrPlural(count, singular, plural) {
  if (count === 1) return singular
  else return plural
}

export function uppercaseFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : string
}
